import { useEffect, useRef } from "react";
import { useDispatchApp } from "../lib/redux";
import { getPathDatabaseByRole } from "../actions/auth";
import {
  startListenerCreativeJobs,
  stopListenerCreativeJobs,
  syncCreativeJobNotifications,
} from "../actions/creativeJobs";

export const useCreativeJobsListener = () => {
  const dispatch = useDispatchApp();
  const listenerRef = useRef(null);
  const { userID: advertiserID } = dispatch(getPathDatabaseByRole());

  useEffect(() => {
    if (!advertiserID) return undefined;

    dispatch(
      startListenerCreativeJobs({
        advertiserID,
        onReferenceAvailable: (reference) => {
          listenerRef.current = reference;
        },
        onUpdatedDataCallback: (jobs) => {
          dispatch(syncCreativeJobNotifications(jobs));
        },
      })
    );

    return () => {
      dispatch(
        stopListenerCreativeJobs({
          listenerRef: listenerRef.current,
        })
      );
      listenerRef.current = null;
    };
  }, [advertiserID, dispatch]);
};
